import { isStringEmpty, nanoid } from '@shared/utils';
import { HelperCore } from '@/common/helper';
import { clearChatStorage } from '@shared/store/chat';

import globalStore from '../global';
import ChatStore from './ChatStore';
import wsStore from '@/components/chat-ws/store';
import inputTypeStore from '@/components/input-file/input-type';
import chatKnowledgeStore from '@/pages/chat-knowledge/store';
import { makeAutoObservable, runInAction } from 'mobx';
import navbarStore from '../navbar';
import client, { SIZE_MODEL_SMALL } from '../client';
import { isAgentFlowId } from '@shared/constants/mcp';

class ChatStoreManager {
  virtualId = nanoid();
  currentId = null;
  _storeMap = new Map();
  newChatLogData = {};
  toolsPlanEditData = {};

  get current() {
    if(globalStore.isKownledgeChat()){
      return chatKnowledgeStore.chatStore;
    }

    return this.get(this.currentId);
  }

  constructor() {
    makeAutoObservable(this);

    if (!HelperCore.IS_PROD) {
      window.__chatStoreManager = this;
    }
  }

  setCurrentId = (id) => {
    runInAction(() => {
      this.currentId = id;
    })
  };

  reset = () => {
    this.currentId = '';
  };

  has = (id) => {
    return this._storeMap.has(id);
  };

  get = (id, type) => {
    return this._storeMap.get(id);
  };

  delete = (id) => {
    if (id === this.currentId) {
      this.setCurrentId('');
    }
    if (this._storeMap.has(id)) {
      const store = this._storeMap.get(id);
      store.abort();
      store.resetState();
      return this._storeMap.delete(id);
    }
    return false;
  };

  clear = () => {
    if (this._storeMap.size > 0) {
      this._storeMap.forEach(store => {
        store.abort();
        store.resetState();
      });
      this._storeMap.clear();
    }
    this.reset();
    clearChatStorage();
  };

  getVirtualId = () => {
    return this.virtualId
  }

   updateToolsPlanEditData = (msg_id, key, data) => {
    runInAction(() => {
      if (!this.toolsPlanEditData[msg_id]) {
        this.toolsPlanEditData[msg_id] = {};
      }
      this.toolsPlanEditData[msg_id][key] = data;
    });
  };

  newChatStore = ({
    type,
    id,
    agentId,
    agentInfo,
    asstId,
    aiAgentId,
    aiAgentFlowId,
    kn_continue_chat,
    conversationData,
    entrance,
    ks_id,
    fold_id,
    file_id
  } = {}) => {
    const store = new ChatStore({ type, id, asstId, agentId, agentInfo, aiAgentId, aiAgentFlowId, entrance });
    if(id){
      this._storeMap.set(id, store);
      this.setCurrentId(id);
      if(conversationData){}
      else {
        store.fetchChatHistory(id, kn_continue_chat, entrance, ks_id, fold_id, file_id);
      }
    }
    else {
      this._storeMap.set(this.virtualId, store);
      this.setCurrentId(this.virtualId);
    }
    return store;
  };

  newChat = async ({
    type,
    asstId,
    input,
    fileType,
    ks_id,
    dataset,
    file,
    field_category,
    kwargs,
    intentRes,
  }) => {
    const store = this.newChatStore({ type, asstId, input });
    if (!isStringEmpty(input)) {
      store.sendMessage({
        asstId, 
        input,
        ks_id,
        dataset,
        file,
        field_category,
        kwargs,
        intentRes,
        ...inputTypeStore.getSendParams(fileType),
      });
    }
    else {
      globalStore.navigate(`/chat`);
    }
  };
  newAgentChat = async ({agentId, agentInfo, prompt}) => {
    const asstId = agentInfo?.basic_info?.llm_model?.id;
    const store = this.newChatStore({ agentId, asstId, agentInfo});
    
    if(prompt){
      store.sendMessage({
        input : prompt,
        onConversationId : conversationId => {
          this._storeMap.set(conversationId, store);
          this.setCurrentId(conversationId);
          globalStore.navigate(`/chat/${conversationId}`);
        }
      });
    }
    else {
      globalStore.navigate(`/chat`);
    }
  };
  newAiAgentChat = async ({aiAgentId, prompt, sendParams}) => {
    const isAgentFlow = isAgentFlowId(aiAgentId);
    const store = this.newChatStore(isAgentFlow ? { aiAgentFlowId : aiAgentId } : { aiAgentId });
    
    // if(prompt){
      if(/^\/agentchat\//.test(location.pathname)){
        globalStore.navigate(`/agentchat`);
      }
      if(/^\/aichat\//.test(location.pathname)){
        globalStore.navigate(`/aichat`);
      }
      store.mcpStore.agentInfoPromise
      .then(() => {
        store.sendMessage({
          input : prompt,
          ...sendParams,
          onConversationId : conversationId => {
            this._storeMap.set(conversationId, store);
            this.setCurrentId(conversationId);
            globalStore.navigate(`/agentchat/${conversationId}`);
          }
        });
      })
    // }
    // else {
    //   globalStore.navigate(`/tools/aiagent`);
    // }
  };
  updateConversationId = (conversationId, body) => {
    if(!this.current){
      return;
    }
    if(this.has(conversationId)){
      return;
    }

    this._storeMap.set(conversationId, this.current);
    this.setCurrentId(conversationId);

    wsStore.setCurrentId(conversationId);
    navbarStore.insertHistory(conversationId, body);

    if(globalStore.isKownledgeChat()){
      return;
    }
    if(client.isClient && client.sizeModel == SIZE_MODEL_SMALL){
      return;
    }

    HelperCore.log(`跳转 chat: ${conversationId}`);
    let pageRoute = 'chat';
    if (globalStore.isAiagentPage() || /^\/agentchat/.test(location.pathname)) {
      pageRoute = 'agentchat';
    }else if (globalStore.isAiso()) {
      pageRoute = 'aichat';
    }
    globalStore.navigate(`/${pageRoute}/${conversationId}`, {replace: globalStore.isAiagentPage()});
  }

  setNewChatLogData (newChatLogData) {
    this.newChatLogData = newChatLogData;
  }
}

const chatStoreManager = new ChatStoreManager();
export default chatStoreManager;
